import * as amplitude from '@amplitude/analytics-browser';
import { AppConfig } from 'config';
import { CourseProvider, DirectionThemeProvider, UserProvider } from 'providers';
import AmplitudeProvider from 'providers/AmplitudeProvider';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';
import { IntercomProvider } from 'react-use-intercom';
import Routes from 'routes';
import TechnicalRoutes from 'routes/technicalWork';
import { GlobalFont } from 'styles/general/globalFont';
import { GlobalStyle, calculateViewportHeight } from 'styles/general/globalStyles';

const startMaintenanceTimestamp = new Date(1714032000 * 1000);
const endMaintenanceTimestamp = new Date(1714037400 * 1000);

const AMPLITUDE_KEY = AppConfig.REACT_APP_AMPLITUDE_KEY;

// Only initialize Amplitude if API key is provided
if (AMPLITUDE_KEY) {
  amplitude.init(AMPLITUDE_KEY, { autocapture: true });
} else {
  console.warn('Amplitude API key not found - analytics will be disabled');
}

const currentTimestamp = new Date();

const isUnderMaintenance = currentTimestamp >= startMaintenanceTimestamp && currentTimestamp <= endMaintenanceTimestamp;

function App() {
  useEffect(() => {
    if (!isUnderMaintenance) {
      calculateViewportHeight();
      window.addEventListener('resize', calculateViewportHeight);
      return () => window.removeEventListener('resize', calculateViewportHeight);
    }
  }, [isUnderMaintenance]);

  if (isUnderMaintenance) {
    return <TechnicalRoutes />;
  } else {
    return (
      <HelmetProvider>
        <UserProvider>
          <DirectionThemeProvider>
            <IntercomProvider appId={AppConfig.REACT_APP_INTERCOM_APP_ID} shouldInitialize>
              <GlobalStyle />
              <GlobalFont />
              <Router>
                <CourseProvider>
                  <AmplitudeProvider>
                    <Routes />
                  </AmplitudeProvider>
                </CourseProvider>
              </Router>
            </IntercomProvider>
          </DirectionThemeProvider>
        </UserProvider>
      </HelmetProvider>
    );
  }
}

export default App;
